import LoginPage from "@/view/account/Login";

export default [
  {
    path: "/login",
    name: "login",
    component: LoginPage,
  },
  {
    path: "/app-login-router/:email/:password/:page/:param1?/:param2?/:param3?",
    name: "app-login-router",
    component: () => import("@/view/account/AppLoginRouter"),
  },
];
